/**
 * Created by alex on 01/03/2025.
 * Description:
 *
 * ------ maintenance history ------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { AppendEntityConfirmDialogComponent } from './append-entity-confirm-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
    ],
    declarations: [
        AppendEntityConfirmDialogComponent
    ],
    exports: [
        AppendEntityConfirmDialogComponent
    ],
    providers: []
})
export class AppendEntityConfirmDialogModule {
}
